import { createContext, useContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export type AuthRole = 'admin' | 'customer';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  role: AuthRole;
  status: 'active' | 'inactive' | 'blocked';
  avatarUrl?: string | null;
}

export interface AuthContextValue {
  configured: boolean;
  loading: boolean;
  session: Session | null;
  user: User | null;
  profile: UserProfile | null;
  role: AuthRole | null;
  welcomeBack: boolean;
  clearWelcomeBack: () => void;
  refreshProfile: () => Promise<UserProfile | null>;
  signIn: (email: string, password: string) => Promise<UserProfile | null>;
  signUp: (name: string, email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider.');
  }

  return context;
}
